import type { Themes } from "@circle-react-shared/BuilderUI/Helpers/setCssVars";
import { setCssVars } from "@circle-react-shared/BuilderUI/Helpers/setCssVars";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";
import { useEffect } from "react";
import { useFrame } from "react-frame-component";

export interface UseSetCssVarsProps {
  appearance: Appearance;
  themes: Themes;
}

export const useSetCssVars = ({ themes, appearance }: UseSetCssVarsProps) => {
  const { document } = useFrame();

  useEffect(() => {
    if (!document) return;

    setCssVars({
      themes,
      appearance,
      document,
    });
  }, [document, themes, appearance]);
};
